function drillDown(btn, panel) {
  const item = btn.closest(".hc-item");
  const parentUl = item.parentElement;

  // Blocca altezza e imposta il riferimento per position absolute
  parentUl.style.minHeight = parentUl.offsetHeight + "px";
  parentUl.style.position = "relative";

  // Nasconde solo i FRATELLI — NON l'item corrente (che contiene il panel)
  parentUl.querySelectorAll(":scope > .hc-item").forEach((li) => {
    if (li !== item) {
      li.style.visibility = "hidden";
    }
  });

  // Nasconde il bottone dell'item corrente (il panel lo sostituisce)
  btn.style.visibility = "hidden";

  // Impedisce che l'item sia il containing block per il panel
  item.style.position = "static";

  // Mostra il panel sopra la lista
  panel.hidden = false;

  // Scroll to top sul contenitore scrollabile esterno
  const scrollContainer = panel.closest('.menu-list__submenu');
  if (scrollContainer) scrollContainer.scrollTop = 0;
  panel.style.position = "absolute";
  panel.style.top = "0";
  panel.style.left = "0";
  panel.style.width = "100%";
  panel.style.zIndex = "1";
  panel.style.backgroundColor = "var(--color-background)";
  panel.style.border = "none";
  panel.style.boxShadow = "none";

  // Aggiungi bottone back se non esiste
  if (!panel.querySelector(":scope > ul > .hc-back-item")) {
    const ul = panel.querySelector("ul");
    const backLi = document.createElement("li");
    backLi.className = "hc-item hc-back-item";

    const backBtn = document.createElement("button");
    backBtn.className = "hc-back-btn";
    backBtn.type = "button";
    backBtn.innerHTML = `<span class="hc-arrow--back" aria-hidden="true">‹</span> <span class="hc-title">${btn.querySelector(".hc-title").textContent.trim()}</span>`;

    backLi.appendChild(backBtn);
    ul.prepend(backLi);

    backBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      drillBack(panel, btn, item, parentUl);
    });
  }

  btn.setAttribute("aria-expanded", "true");
}

function drillBack(panel, btn, item, parentUl) {
  // Chiudi eventuali pannelli annidati dentro
  panel.querySelectorAll(".hc-panel").forEach((p) => {
    p.hidden = true;
    p.style.cssText = "";
  });
  panel.querySelectorAll(".hc-parent").forEach((b) =>
    b.setAttribute("aria-expanded", "false")
  );
  panel.querySelectorAll(".hc-item").forEach((li) => {
    li.style.position = "";
    li.style.visibility = "";
  });
  panel.querySelectorAll(".hc-parent").forEach((b) => {
    b.style.visibility = "";
  });

  // Nascondi il panel
  panel.hidden = true;
  panel.style.cssText = "";

  // Ripristina item fratelli
  parentUl.querySelectorAll(":scope > .hc-item").forEach((li) => {
    li.style.visibility = "";
  });

  // Ripristina bottone e item corrente
  btn.style.visibility = "";
  item.style.position = "";
  btn.setAttribute("aria-expanded", "false");

  // Resetta il parentUl
  parentUl.style.minHeight = "";
  parentUl.style.position = "";
}

function resetAll() {
  document.querySelectorAll(".hc-panel").forEach((p) => {
    p.hidden = true;
    p.style.cssText = "";
  });
  document.querySelectorAll(".hc-parent").forEach((b) => {
    b.setAttribute("aria-expanded", "false");
    b.style.visibility = "";
  });
  document.querySelectorAll(".hc-item").forEach((li) => {
    li.style.visibility = "";
    li.style.position = "";
  });
  document.querySelectorAll(".hc-menu").forEach((ul) => {
    ul.style.minHeight = "";
    ul.style.position = "";
  });
}

document.addEventListener("click", (e) => {
  if (e.target.closest(".hc-back-btn")) return;

  const btn = e.target.closest(".hc-parent");
  if (!btn) return;

  const item = btn.closest(".hc-item--has-children");
  if (!item) return;

  const panel = item.querySelector(":scope > .hc-panel");
  if (!panel) return;

  const isOpen = btn.getAttribute("aria-expanded") === "true";

  if (isOpen) {
    drillBack(panel, btn, item, item.parentElement);
  } else {
    drillDown(btn, panel);
  }
});

// Click fuori = reset completo
document.addEventListener("click", (e) => {
  if (e.target.closest(".hc-item")) return;
  resetAll();
});

// Blocca navigazione su link #
document.addEventListener("click", (e) => {
  const link = e.target.closest("a[href='#']");
  if (!link) return;
  e.preventDefault();
});